/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Metryka proby: N i skrajne daty wybranego okna. Bez fetch — dane dostaje z analiza.js. */
(function () {
    'use strict';

    function calkowita(v) {
        return typeof v === 'number' && isFinite(v) && Math.floor(v) === v && v >= 0;
    }

    function napis(v) {
        return typeof v === 'string' && v !== '';
    }

    // Daty tylko wtedy, gdy zakres_dat opisuje DOKLADNIE te sama probe co N.
    function model(okno, zakres) {
        var pusty = { N: null, od: null, do: null };
        if (!okno || okno.powod || !calkowita(okno.losowan)) return pusty;

        var zd = okno.zakres_dat;
        if ((!zd || !napis(zd.od) || !napis(zd.do)) && zakres && Array.isArray(zakres.roczniki)) {
            var roczne = zakres.roczniki.map(function (r) { return r && r.zakres_dat; })
                .filter(function (r) { return r && calkowita(r.N) && napis(r.od) && napis(r.do); });
            var suma = roczne.reduce(function (n, r) { return n + r.N; }, 0);
            if (roczne.length && suma === okno.losowan) {
                zd = { N: suma, od: roczne[0].od, do: roczne[roczne.length - 1].do };
            }
        }
        if (!zd || !calkowita(zd.N) || zd.N !== okno.losowan || !napis(zd.od) || !napis(zd.do)) {
            return { N: okno.losowan, od: null, do: null };
        }
        return { N: okno.losowan, od: zd.od, do: zd.do };
    }

    function zakresNapis(klucz, zakres) {
        var en = /^en(?:-|$)/i.test(document.documentElement.lang || '');
        if (zakres && zakres.od != null && zakres.do != null) {
            return en ? jst("fragment.6047e77005308efd") + zakres.od + '–' + zakres.do : jst("fragment.8272b56d65ce7954") + zakres.od + '–' + zakres.do;
        }
        if (klucz === 'all') return jst("pages_metryka_proby_js.d952f4288e62");
        if (String(klucz) === '1') return jst("pages_metryka_proby_js.9799c1515407");
        return klucz != null ? String(klucz) + (jst("pages_metryka_proby_js.76f612b6a4e6")) : '—';
    }

    function swiezosc(root, latest) {
        var el = root && root.querySelector('[data-okres-freshness]');
        if (!el) return;
        var en = /^en(?:-|$)/i.test(document.documentElement.lang || '');
        var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(latest || ''));
        if (!m) { el.textContent = jst("pages_metryka_proby_js.f2419d4f1c9f"); return; }
        var then = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
        var now = new Date(), today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
        var days = Math.max(0, Math.floor((today - then) / 86400000));
        var game = el.getAttribute('data-game') || '';
        var limit = ({'mini-lotto':2,'multi-multi':2,'kaskada':2,'lotto':5,'lotto-plus':5,'eurojackpot':5})[game] || 7;
        el.setAttribute('data-freshness-status', days <= limit ? 'current' : 'delayed');
        el.textContent = days <= limit
            ? (en ? jst("ui.d7248bc6cb1a5b7b") + days + (days === 1 ? jst("ui.d7b6adcdb230f55e") : jst("ui.afb7f21e9d087028")) : jst("ui.b24ca013249a1156") + days + (days === 1 ? jst("pages_metryka_proby_js.literal.09fbe76820ef") : jst("ui.4274a9f87cb245d1")))
            : (en ? jst("ui.61e3e170f1ccd7a1") + days + jst("ui.afb7f21e9d087028") : jst("pages_metryka_proby_js.literal.7db7997c6807") + days + jst("ui.4274a9f87cb245d1"));
    }

    function render(root, okno, klucz, dane, zakres) {
        if (!root) return;
        var m = model(okno, zakres);
        root.querySelectorAll('[data-okres-date]').forEach(function (el) {
            el.hidden = m.od === null || m.do === null;
        });
        ['N', 'od', 'do', 'ostatnie'].forEach(function (k) {
            var el = root.querySelector('[data-okres-value="' + k + '"]');
            if (!el) return;
            var wartosc = k === 'ostatnie' ? m.do : m[k];
            el.textContent = wartosc === null ? '—' : String(wartosc);
        });
        swiezosc(root, m.do);
        var zakresEl = root.querySelector('[data-okres-value="zakres"]');
        if (zakresEl) zakresEl.textContent = zakresNapis(klucz, zakres);
        var pulaEl = root.querySelector('[data-okres-value="pula"]');
        if (pulaEl && dane && dane.pula != null) pulaEl.textContent = String(dane.pula);
    }

    window.PEWNIAKI_METRYKA = { model: model, render: render };

    var strona = document.querySelector('[data-analiza-strona]');
    var root = strona && strona.querySelector('[data-okres-metryka]');
    var api = window.PEWNIAKI_ANALIZA;
    if (root) swiezosc(root, root.querySelector('[data-okres-freshness]') && root.querySelector('[data-okres-freshness]').getAttribute('data-latest'));
    if (!root || !api || typeof api.render !== 'function' || api.__metrykaOpakowana) return;

    var oryginal = api.render;
    api.render = function (okno, klucz, dane, zakres) {
        var wynik = oryginal.apply(this, arguments);
        render(root, okno, klucz, dane, zakres);
        return wynik;
    };
    api.__metrykaOpakowana = true;
})();
